import { auth } from "@lumberset/api-client";
import { Button, Field, Heading, Input } from "@lumberset/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import { type FormEvent, useState } from "react";

export const Route = createFileRoute("/_auth/forgot-password")({ component: ForgotPassword });

function ForgotPassword() {
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setBusy(true);
    await auth.requestPasswordReset({
      email: String(new FormData(event.currentTarget).get("email")),
      redirectTo: `${window.location.origin}/set-password`,
    });
    // The same message whether or not the address has an account.
    setBusy(false);
    setSent(true);
  }

  if (sent) {
    return (
      <div className="flex flex-col gap-y-4">
        <Heading>Check your email</Heading>
        <p className="txt-small text-ui-fg-subtle">
          If that address has a LumberSet account, a link to choose a new password is on its way. It
          works for one hour.
        </p>
        <Button asChild variant="secondary" size="large" block>
          <Link to="/login">Back to sign in</Link>
        </Button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-y-5">
      <div>
        <Heading>Reset your password</Heading>
        <p className="txt-small mt-1 text-ui-fg-subtle">
          We will email you a link to choose a new one.
        </p>
      </div>
      <Field label="Email">
        {(control) => (
          <Input
            {...control}
            name="email"
            type="email"
            autoComplete="email"
            required
            size="large"
            autoFocus
          />
        )}
      </Field>
      <Button type="submit" size="large" block isLoading={busy}>
        Send reset link
      </Button>
      <Link
        to="/login"
        className="txt-small text-center text-ui-fg-interactive hover:text-ui-fg-interactive-hover"
      >
        Back to sign in
      </Link>
    </form>
  );
}
